import {useMemo} from 'react'
import {ActionState, type CurrentState, type PlayerColor, TurnState} from '@colonist/game-states'
import {type TranslationObject} from '@colonist/i18n'

export const useIsDiceActive = (currentState: CurrentState, playerColor: PlayerColor, myColor: PlayerColor, currentTurnPlayers: PlayerColor[]): {
    active: boolean
    helperText: TranslationObject | undefined
} => useMemo(() => {
    if(currentTurnPlayers.length > 1) {
        return {
            active: false,
            helperText: undefined,
        }
    }
    if(myColor !== playerColor) {
        return {
            active: false,
            helperText: undefined,
        }
    }
    if(currentState.currentTurnPlayerColor !== playerColor) {
        return {
            active: false,
            helperText: {key: 'strings:game.errors.notYourTurn'},
        }
    }
    if(currentState.turnState != TurnState.Dice) {
        return {
            active: false,
            helperText: {key: 'strings:game.errors.diceAlreadyRolled'},
        }
    }
    if(currentState.actionState !== ActionState.None) {
        return {
            active: false,
            helperText: {key: 'strings:game.errors.finishCurrentAction'},
        }
    }

    return {
        active: true,
        helperText: undefined,
    }
}, [currentState, playerColor, myColor])

export const useIsDiceVisible = (currentState: CurrentState, currentTurnPlayers: PlayerColor[], playerColor: PlayerColor): boolean => useMemo(() => {
    if(currentState.turnState === TurnState.InitialPlacement) {
        return false
    }
    const isCurrentPlayerTurn = currentTurnPlayers.includes(playerColor)
    return isCurrentPlayerTurn
}, [currentState, currentTurnPlayers, playerColor])

